<script>
import VTextFieldPassword from "@/components/commonComponents/VTextFieldPassword.vue";
import VAutocompleteCompany from "@/components/VAutocomplete/VAutocompleteCompany.vue";
import VAutocompleteRoles from "@/components/VAutocomplete/VAutocompleteRoles.vue";
import CommonRules from "@/mixins/CommonRules";
import UserAuth from "@/mixins/UserAuth";

export default {
    name: "UsersModalCommon",
    inheritAttrs: false,
    components: {
        VAutocompleteRoles,
        VAutocompleteCompany,
        VTextFieldPassword,
    },
    mixins: [
        CommonRules,
        UserAuth,
    ],
    props: {
        data: {
            type: Object,
        },
        isDisabledField: {
            type: Function,
            required: true,
        },
        isNew: {
            type: Boolean,
        },
    },
    computed: {
        minPasswordLengthValidator() {
            return this.rules.minPasswordLength(this.user.settings.password.length);
        },
    },
}
</script>

<template>
    <v-container class="pa-0">
        <v-row no-gutters>
            <v-col>
                <!-- @TODO: rules.email -->
                <v-text-field
                    v-model="data.email"
                    :rules="[rules.required]"
                    :disabled="isDisabledField('email')"
                    label="E-mail"
                    class="required"
                    autofocus
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mr-2">
                <v-text-field-password
                    v-model="data.password"
                    :rules="isNew ? [rules.required, minPasswordLengthValidator] : [minPasswordLengthValidator]"
                    :disabled="isDisabledField('password')"
                    :class="{required: isNew}"
                    label="Пароль"
                ></v-text-field-password>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-switch
                    v-model="data.is_active"
                    :true-value="1"
                    :false-value="0"
                    :disabled="isDisabledField('is_active')"
                    label="Активен"
                    class="mt-0 pt-0"
                ></v-switch>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mr-2">
                <v-text-field
                    v-model="data.first_name"
                    :rules="[rules.required]"
                    :disabled="isDisabledField('first_name')"
                    class="required"
                    label="Имя"
                ></v-text-field>
            </v-col>
            <v-col class="ml-2">
                <v-text-field
                    v-model="data.last_name"
                    :rules="[rules.required]"
                    :disabled="isDisabledField('last_name')"
                    class="required"
                    label="Фамилия"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-text-field
                    v-model="data.position"
                    :rules="[rules.required]"
                    :disabled="isDisabledField('position')"
                    class="required"
                    label="Должность"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-autocomplete-company
                    v-model="data.id_companies"
                    :rules="[rules.required]"
                    :disabled="isDisabledField('id_companies')"
                    @updated="result = true"
                    class="required"
                ></v-autocomplete-company>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-autocomplete-roles
                    v-model="data.id_roles"
                    :rules="[rules.required]"
                    :disabled="isDisabledField('id_roles')"
                    class="required"
                ></v-autocomplete-roles>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped lang="scss">

</style>
